import ApplicationsList2 from './ApplicationsList2';

export default ApplicationsList2;
